import { dateColumn, numberColumn, primaryRelationshipColumn, relationshipColumn } from "@api/schema/columnHelpers";
import { objectDefinition } from "@api/schema/supportedObjects";
import RapidReinvestmentSection from "./RapidReinvestmentSection";
import { forwardRef } from "react";

const relationshipType = 'business';
const {pluralName, color, endpoint} = objectDefinition(relationshipType);
const columns = [
    primaryRelationshipColumn({column: 'id', endpoint, required: true}),
    dateColumn({column: 'date', label: 'Date', required: true}),
    numberColumn({column: 'full_time', label: 'Full-time Employees', inputType: 'number'}),
    numberColumn({column: 'part_time', label: 'Part-time Employees', inputType: 'number'}),
    numberColumn({column: 'seasonal', label: 'Seasonal Employees', inputType: 'number'}),
];

const EmployeeChanges = forwardRef(function EmployeeChanges(props, ref) {
    return (
        <RapidReinvestmentSection
            type={relationshipType}
            columns={columns}
            {...props}
            ref={ref}
        />
    )
});

export {EmployeeChanges};
